import { createActionGroup, emptyProps, props } from '@ngrx/store'
import { ApplicationError } from '../../../error/model/error'
import {
  ClientSearch,
  CreditSubmissionStructure,
  CreditSubmissionUserTranche,
  CreditSubmissionReinsurer,
} from '../../model/credit-submission.model'
import { CreditEmail } from './../../model/credit-email.model'
import { CreditCalculationStructure } from '../../model/credit-structure.model'

export const CreditSubmissionStatusActions = createActionGroup({
  source: 'Credit Submission Status',
  events: {
    Finalize: emptyProps(),
    'Finalize Failure': props<{ error: ApplicationError }>(),
    'Finalize Success': props<{
      structure: CreditSubmissionStructure
    }>(),
    'Send For Approval': emptyProps(),
    'Send For Approval Failure': props<{ error: ApplicationError }>(),
    'Send For Approval Success': props<{
      structure: CreditSubmissionStructure
    }>(),
    'Send For Approval Email': props<{ email: CreditEmail }>(),
    'Send For Approval Email Failure': props<{ error: ApplicationError }>(),
    'Send For Approval Email Success': props<{ email: CreditEmail }>(),
    'Send Back': props<{ email: CreditEmail }>(),
    'Send Back Failure': props<{ error: ApplicationError }>(),
    'Send Back Success': props<{
      structure: CreditSubmissionStructure
    }>(),
    Approve: emptyProps(),
    'Approve Failure': props<{ error: ApplicationError }>(),
    'Approve Success': props<{
      structure: CreditSubmissionStructure
    }>(),
    'Send To Market': emptyProps(),
    'Send To Market Failure': props<{ error: ApplicationError }>(),
    'Send To Market Success': props<{
      structure: CreditSubmissionStructure
    }>(),
    'Send To Market Email': props<{ email: CreditEmail }>(),
    'Send To Market Email Failure': props<{ error: ApplicationError }>(),
    'Send To Market Email Success': props<{ email: CreditEmail }>(),
  },
})

export const CreditSubmissionStructureActions = createActionGroup({
  source: 'Credit Submission Structure',
  events: {
    'Reset Selected Submission': emptyProps(),
    'Set Selected Filters': props<{ filters: ClientSearch }>(),
    'Set Gse Selected Filters': props<{ filters: ClientSearch }>(),
    'Get Submission Structures Failure': props<{ error: ApplicationError }>(),
    'Get Submission Structures Success': props<{
      structures: CreditSubmissionStructure[]
    }>(),
    'Get Gse Submission Structures Success': props<{
      structures: CreditSubmissionStructure[]
    }>(),
    'Set Selected Submission': props<{
      structure: CreditSubmissionStructure
    }>(),
    'Update Selected Submission': props<{
      structure: CreditSubmissionStructure
    }>(),
    'Save Selected Submission Client': emptyProps(),
    'Save Selected Submission Client Success': props<{
      userTranches: CreditSubmissionUserTranche[]
    }>(),
    'Save Selected Submission Reinsurers': emptyProps(),
    'Save Selected Submission Reinsurers Success': props<{
      userTranches: CreditSubmissionUserTranche[]
    }>(),
    'Reinitialize Tower Submission': props<{ structureId: string }>(),
    Fetch: props<{ structureId: string }>(),
    'Fetch Success': props<{ structure: CreditSubmissionStructure }>(),
    'Fetch Failure': props<{ error: ApplicationError }>(),
    Put: emptyProps(),
    'Put Success': props<{ structure: CreditSubmissionStructure }>(),
    'Put Failure': props<{ error: ApplicationError }>(),
    'Fetch Reinsurer And User Ids': props<{ submissionId: number }>(),
    'Fetch Reinsurer And User Ids Success': props<{ structure: CreditSubmissionStructure }>(),
    'Fetch Reinsurer And User Ids Failure': props<{ error: ApplicationError }>(),
    'Fetch Gse Reinsurer And User Ids': props<{ submissionId: number }>(),
  },
})

export const CreditSubmissionReinsurerActions = createActionGroup({
  source: 'Credit Submission Reinsurer',
  events: {
    'Update Viewed Status': props<{ submissionId: number }>(),
    'Update Viewed Status Success': props<{
      reinsurer: CreditSubmissionReinsurer
    }>(),
    'Update Viewed Status Failure': props<{ error: ApplicationError }>(),
  },
})

export const CreditSubmissionUserTrancheActions = createActionGroup({
  source: 'Credit Submission User Tranche',
  events: {
    Fetch: props<{ submissionId: number }>(),
    'Fetch Failure': props<{ error: ApplicationError }>(),
    'Fetch Success': props<{ tranches: CreditSubmissionUserTranche[] }>(),
    Update: props<{ tranche: CreditSubmissionUserTranche }>(),
    Save: emptyProps(),
    'Save Failure': props<{ error: ApplicationError }>(),
    'Save Success': props<{ tranches: CreditSubmissionUserTranche[] }>(),
  },
})
